// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"Modal_backdrop__1mfF6","modal":"Modal_modal__4DXUe","slide-down":"Modal_slide-down__W3MdX","button-div":"Modal_button-div__1JV7u"};